// Back-order UI
// Self-contained companion script. Rides the theme's official
// `product:variant-change` custom event (Fluorescent Stiletto v6) to swap the
// add-to-cart button label to "Backorder" and reveal the "(ships in 2-4 weeks)"
// lead time inside the same button whenever the selected variant is on back-order.
//
// A variant is considered back-order when the server-rendered
// `[data-backorder-json]` map marks its ID as true (tracked + continue + <=0 qty).
//
// Requires `useCustomEvents` to be enabled in theme-globals.liquid.

(function () {
  var BACKORDER_LABEL = 'Backorder';

  // Find the nearest product container so multiple product forms on one page
  // (e.g. featured product, quick view) stay isolated from each other.
  function closestProductScope(el) {
    return (
      el.closest('[data-section-type="product"]') ||
      el.closest('[data-section-id]') ||
      document
    );
  }

  // Read the back-order map rendered by backorder-data.liquid within a scope.
  function readBackorderMap(scope) {
    var node = scope.querySelector('[data-backorder-json]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return null;
    }
  }

  function applyState(scope, variantId) {
    if (!scope || variantId == null) return;

    var map = readBackorderMap(scope);
    if (!map) return;

    var isBackorder = map[String(variantId)] === true;

    var button = scope.querySelector('[data-add-to-cart]');
    if (!button) return;

    var buttonText = scope.querySelector('[data-add-to-cart-text]');
    var lead = scope.querySelector('[data-backorder-lead]');

    // Only override the label when the variant is actually purchasable. A true
    // sold-out (deny policy) stays disabled and keeps the theme's own handling.
    var variantIsAvailable = !button.hasAttribute('disabled');

    if (isBackorder && variantIsAvailable) {
      if (buttonText) buttonText.textContent = BACKORDER_LABEL;
      button.setAttribute('aria-label', BACKORDER_LABEL);
      if (lead) lead.removeAttribute('hidden');
    } else {
      // Restore the theme's own default label from the data attribute it already
      // exposes, so a stale "Backorder" is never left behind.
      if (buttonText) {
        var defaultLabel = button.getAttribute('data-lang-available');
        if (defaultLabel) buttonText.textContent = defaultLabel;
      }
      if (lead) lead.setAttribute('hidden', '');
    }
  }

  // Re-apply after the theme's own JS has had a chance to rewrite the button.
  // The theme swaps button text on variant change; running again on the next
  // frame ensures our label wins rather than being overwritten a moment later.
  function applyStateDeferred(scope, variantId) {
    applyState(scope, variantId);
    requestAnimationFrame(function () {
      applyState(scope, variantId);
    });
  }

  // Live updates: the theme fires this whenever a variant is selected.
  document.addEventListener('product:variant-change', function (evt) {
    var variant = evt && evt.detail && evt.detail.variant;
    if (!variant) return;

    var scope =
      evt.target && evt.target.nodeType === 1
        ? closestProductScope(evt.target)
        : document;

    applyStateDeferred(scope, variant.id);
  });

  // Initial paint: Liquid already renders the correct state at load, but sync
  // once in case the selected variant is resolved by JS after load.
  document.addEventListener('DOMContentLoaded', function () {
    var forms = document.querySelectorAll('[data-product-form]');
    forms.forEach(function (form) {
      var scope = closestProductScope(form);
      var selected = form.querySelector('[data-variant-select]');
      if (selected && selected.value) applyState(scope, selected.value);
    });
  });
})();
